export const API_ROUTES = {
  SUBSCRIPTION_GROUPS: '/api/v1/management/subscription_groups',
  SUBSCRIPTIONS: '/api/v1/management/subscriptions'
};
